import { isSaasCommercialBuyer } from "@/lib/accountStatus";
import { canShowCommercialLicenseRequestUi } from "@/lib/commercialLicenseRequests";

/**
 * ¿Ocultar bloques técnicos legacy (FIEL, huellas, pegar clave, SAT diagnose) en Configuración?
 *
 * Desacoplado de `can_generate_licenses` para comprador/titular SaaS: el flag del backend
 * no debe convertir al comprador en vista de emisor técnico en modo despacho.
 *
 * @param {object} ctx
 * @param {object} [ctx.user]
 * @param {string} [ctx.workspaceMode]
 * @param {boolean} [ctx.canSwitch]
 * @param {boolean} [ctx.buyerPreviewUx]
 * @param {boolean} [ctx.blockBuyerCommercialUi]
 * @param {boolean} [ctx.emisorView]
 * @param {boolean} [ctx.canGenerateLicenses] — info.can_generate_licenses o user.can_generate_licenses
 */
export function shouldHideBuyerTechnicalUi(ctx = {}) {
  const {
    user = {},
    workspaceMode = "despacho",
    canSwitch = false,
    buyerPreviewUx = false,
    blockBuyerCommercialUi = false,
    emisorView = false,
    canGenerateLicenses = false,
  } = ctx;

  const isBuyerCommercialFlow =
    !emisorView
    && canShowCommercialLicenseRequestUi(user, {
      workspaceMode,
      canSwitch,
      buyerPreviewUx,
    });

  if (!isBuyerCommercialFlow || blockBuyerCommercialUi) return false;

  if (isSaasCommercialBuyer(user)) return true;
  if (buyerPreviewUx) return true;

  // Titular legacy con emisión en despacho (p. ej. dev local): conservar vista técnica.
  if (canGenerateLicenses) return false;

  return true;
}

/** @param {object} ctx — mismos campos que shouldHideBuyerTechnicalUi */
export function shouldSkipBuyerSecurityKeys(ctx = {}) {
  return shouldHideBuyerTechnicalUi(ctx);
}

/** @param {object} ctx — mismos campos; entryMode despacho fuerza evaluación comercial */
export function shouldHideBuyerTechnicalSatDiagnose(ctx = {}) {
  if (ctx.entryMode && ctx.entryMode !== "despacho") return false;
  return shouldHideBuyerTechnicalUi(ctx);
}

/**
 * ¿Ocultar pestañas administrativas en Configuración (Usuarios técnico, Limpieza)?
 * Misma regla que vista limpia Mi Negocio para comprador SaaS / titular comercial.
 */
export function shouldHideBuyerConfigAdminTabs(ctx = {}) {
  return shouldHideBuyerTechnicalUi(ctx);
}
